export const REGULAMENTACOES = 'REGULAMENTACOES';
export const REGULAMENTACOES_START = 'REGULAMENTACOES_START';
export const REGULAMENTACOES_SUCCESS = 'REGULAMENTACOES_SUCCESS';
export const REGULAMENTACOES_ERROR = 'REGULAMENTACOES_ERROR';
